//@ts-nocheck
import { values } from "lodash";
import {
  SEducationHistoryType,
  SLocationInfoType,
  SPersonalInfoType,
  SSubjectSelectionType,
} from "./stores";
import { STEPS } from "./stores/rootStore";
import { SUBJECT_EDIT_STEPS } from "./stores/subject";
import type { TutorDataType } from "./stores/types";

export type AdapterType = {
  regionKey: string;
  countryKey: string;
  supportedCountriesKey: string;
  tuteriaSubjectsKey: string;
  cleanTutorData: any;
  cleanSubjectData: any;
  validateFormStep: (formValues: any, step: string) => Promise<any>;
  getPriceSuggestion: (subject: string) => Promise<{
    minimum?: string;
    maximum?: string;
    recommended?: string;
  }>;
  bookLessons: (requestSlug: string, sessions: any[]) => Promise<any>;
  updateTutorResponse: (
    payload: any,
    requestSlug: string,
    tutorSlug: string,
    agent: any,
  ) => Promise<any>;
  getEarningPercentage: () => number;
  checkSpellingAndGrammar: (checks: any[]) => Promise<any>;
  buildQuizToTake: (subjectInfo: any) => Promise<any>;
  beginQuiz: (
    payload: { subjects: string[] },
    subject_data?: { skill_id: any; payload: any },
  ) => Promise<any>;
  deleteSubject: (id: string) => Promise<any>;
  deleteBulkSubjects: (ids: Array<string>, status?: string) => Promise<any>;
  saveTutorSubjects: (subjects: any[]) => Promise<any[]>;
  saveTutorInfo: (
    key: string,
    value: any,
    slug: string,
    nextStep: string,
    currentStep?: string,
  ) => Promise<any>;
  uploadAndVerifyProfile: (
    file: any,
    slug?: string,
  ) => Promise<{ profile_id: string; url: string; quality: boolean }>;
  updateTutorSubjectInfo: (
    key: string,
    values: any,
    subject_id: string | number,
  ) => Promise<any>;
  submitSelectedSubjects: (data: any) => Promise<any>;
  // fetchQuizQuestions: (quizSubjects: any) => Promise<any>;
  fetchBanksInfo: (supportedCountryName: string) => Promise<string[]>;
  uploadApiHandler: (files: any, options: any) => Promise<any>;
  cloudinaryApiHandler: (files: any, progressCallBack: any) => Promise<any>;
  remoteDeleteImage: (files: any) => Promise<any>;
  saveSubjectImages: (
    imageFiles: { caption?: string; file: any; preview: string }[],
  ) => Promise<Array<{ id: any; url: string; caption: string }>>;
  deleteSubjectImage: (photoId: string) => Promise<any>;
  postResults: (
    name: string,
    gradedResult: {
      passed: boolean;
      avgPassmark: number;
      totalQuizGrade: number;
      result: {
        score: number;
        passed: boolean;
        passmark: number;
        subject: string;
      }[];
    },
    flagged: any,
  ) => Promise<any>;
  [key: string]: any;
};
export type ResponseType = {
  tutorInfo: TutorDataType;
  subjectData: {
    tutorSubjects: any[];
    tuteriaSubjects: any[];
    groups: any[];
    jobSubjects: any[];
  };
  accessToken: string;
  staticData: {
    regions: any[];
    countries: any[];
    supportedCountries: any[];
    educationData?: {
      degree_data: Array<{ name: string; abbrev: string; rank: number }>;
      grade_data: string[];
      specialities: string[];
      sources?: string[];
      languages?: string[];
    };
    pricing: any[];
  };
};
export type ServerAdapterType = {
  // initializeSubject: (
  //   adapter: AdapterType,
  //   subjectInfo: any,
  //   key?: string
  // ) => Promise<{
  //   response: ResponseType;
  //   foundSubject: { quizzes: Array<{ name: string }> };
  // }>;
  getSubjectData: () => any;
  validatePersonalInfo: (params?: any) => Promise<any>;
  getPriceSuggestion: (subject?: string) => Promise<any>;
  getEarningPercentage: () => number;
  initializeApplication: (
    adapter: AdapterType,
    params: {
      regions: any[];
      countries: any[];
      tuteriaSubjects: any[];
    },
  ) => Promise<ResponseType>;
  checkSpellingAndGrammar: (checks: any[]) => Promise<any>;
  saveSubjectImages: (
    imageFiles: Array<{ caption?: string; file: File; preview: string }>,
  ) => Promise<Array<{ id: any; url: string; caption: string }>>;
  saveSubject: (subject_id: number, subject: any) => void;
  loadExistingSubject: (subject_id: string | number) => any;
  uploadAndVerifyProfile: (
    files: any,
  ) => Promise<{ profile_id: string; url: string; quality: boolean }>;
  beginQuiz: (
    payload: { subjects: string[] },
    subject_data?: { skill_id: any; payload: any },
  ) => Promise<void>;
  buildQuizData: (subjectInfo: any, quizzes?: any[]) => Promise<any>;
  deleteSubject: (id: string) => Promise<any>;
  deleteBulkSubjects: (ids: Array<string>, status?: string) => Promise<any>;
  saveTutorInfo: (data: { slug: string; data: any }) => Promise<string>;
  loadExistingTutorInfo: () => any;
  updateUserPassword: (data: PasswordType) => Promise<any>;
  getTutorSubject: (
    tutorSubjects: any[],
    subjectInfo: any,
    key?: string,
  ) => { quizzes: any[]; [key: string]: any };
  getTuteriaSubjects: () => any[];
  fetchLandingPageTutors: () => Promise<any[]>;
  updateTutorSubjectInfo: (
    data: any,
    subject_id: string | number,
  ) => Promise<any>;
  submitSelectedSubjects: (data: any) => Promise<any>;
  fetchBanksInfo: (supportedCountryName: string) => Promise<Array<string>>;

  uploadApiHandler: (
    files: any[],
    options: { folder: string; unique?: boolean },
  ) => Promise<any[]>;
  cloudinaryApiHandler: (files: any[], progressCallback: any) => Promise<any[]>;
  remoteDeleteImage: (files: any) => Promise<any>;
  validateCredentials: () => any;
  beginTutorApplication: (data: any) => Promise<{ redirectUrl: string }>;
  authenticateUser: (data: { email: string; otp?: string }) => Promise<any>;
  saveTutorSubjects: (subjects: string[]) => Promise<any>;
  sendEmailVerification: (data: {
    email: string;
    code?: string;
  }) => Promise<any>;
  submitVideoRecording: (url: string) => Promise<any>;

  submitQuizResults: (payload: {
    name: string;
    grading: {
      passed: boolean;
      avgPassmark: number;
      totalQuizGrade: number;
      result: Array<{
        score: number;
        passed: boolean;
        passmark: number;
        subject: string;
      }>;
    };
    flagged?: Array<{ subject: string; questions: number[] }>;
  }) => Promise<any>;
  saveOnBlur: (name, value) => void;
  [key: string]: any;
};
const REGION_KEY = "TEST-REGIONS-VICINITIES";
const COUNTRY_KEY = "TEST-COUNTRIES";
const SUPPORTED_COUNTRIES_KEY = "TEST-SUPPORTED-COUNTRIES";
const TUTERIA_SUBJECTS_KEY = "TUTERIA_SUBJECTS";
const SUBJECT_DESCRIPTION = "SUBJECT_DESCRIPTION";
const TEACHING_STYLE = "TEACHING_STYLE";
const TRACK_RECORD = "TRACK_RECORD";
const subjectDescriptionMapping = {
  description: SUBJECT_DESCRIPTION,
  trackRecords: TRACK_RECORD,
  teachingStyle: TEACHING_STYLE,
};

type PasswordType = {};
type VerificationInfoType = {};
type ScheduleInfoType = {};
type AgreementInfoType = {};
type NewDevelopmentInfoType = {};
type PaymentInfoType = {};
type TeachingProfileType = {};

type SubmissionType = {
  "personal-info": SPersonalInfoType;
  "location-info": SLocationInfoType;
  "education-history": SEducationHistoryType;
  "work-history": SEducationHistoryType;
  "subject-selection": SSubjectSelectionType;
  "verification-info": VerificationInfoType;
  "schedule-info": ScheduleInfoType;
  "agreement-info": AgreementInfoType;
  "guarantors-info": SEducationHistoryType;
  "payment-info": PaymentInfoType;
  "new-development-info": NewDevelopmentInfoType;
  "teaching-profile": TeachingProfileType;
};

export function loadAdapter(_adapter: ServerAdapterType): AdapterType {
  return {
    regionKey: REGION_KEY,
    countryKey: COUNTRY_KEY,
    supportedCountriesKey: SUPPORTED_COUNTRIES_KEY,
    tuteriaSubjectsKey: TUTERIA_SUBJECTS_KEY,
    uploadAndVerifyProfile: _adapter.uploadAndVerifyProfile,
    deleteSubject: _adapter.deleteSubject,
    deleteBulkSubjects: _adapter.deleteBulkSubjects,
    buildPreferences: _adapter.buildPreferences,
    cleanSubjectData(existingData, key, value) {
      let result = {
        heading: existingData.title,
        description: existingData.description,
        certifications: (existingData.certifications || []).map((o) => ({
          award_name: o.name,
          award_institution: o.institution,
        })),
        hourlyRate: existingData.hourlyRate,
        other_info: {
          teachingStyle: existingData.teachingStyle,
          trackRecords: existingData.trackRecords,
          teachingRequirements: existingData.teachingRequirements,
          preliminaryQuestions: existingData.preliminaryQuestions,
          agree: existingData.agree,
          preferences: existingData.preferences,
          additionalStudents: existingData.additionalStudents,
        },
        exhibitions: (existingData.exhibitions || []).map((j) => ({
          image: j.id,
          caption: j.caption,
        })),
        preferences: existingData.preferences,
      };
      if (key === SUBJECT_EDIT_STEPS.HEADING) {
        result.heading = value.title;
      }
      if (key === SUBJECT_EDIT_STEPS.DESCRIPTIONS) {
        result.description = value.description;
        result.other_info = {
          ...result.other_info,
          trackRecords: value.trackRecords,
          teachingStyle: value.teachingStyle,
        };
      }
      if (key === SUBJECT_EDIT_STEPS.IMAGES) {
        result.exhibitions = value.exhibitions.map((o) => ({
          image: o.id,
          caption: o.caption,
        }));
      }
      if (key === SUBJECT_EDIT_STEPS.REQUIREMENTS) {
        result.other_info = {
          ...result.other_info,
          teachingRequirements: value.teachingRequirements,
        };
      }
      if (key === SUBJECT_EDIT_STEPS.PREFERENCES) {
        result.other_info = {
          ...result.other_info,
          preferences: value.preferences,
        };
      }
      if (key === SUBJECT_EDIT_STEPS.PRICING) {
        result.hourlyRate = value.hourlyRate;
        result.other_info = {
          ...result.other_info,
          agree: value.agree,
        };
      }
      if (key === SUBJECT_EDIT_STEPS.ADDITIONAL_STUDENT_PRICING) {
        result.other_info = {
          ...result.other_info,
          additionalStudents: value.additionalStudents || 0,
        };
      }
      if (key === SUBJECT_EDIT_STEPS.CERTIFICATIONS) {
        result.certifications = value.certifications.map((cert) => ({
          award_name: cert.name,
          award_institution: cert.institution,
        }));
      }
      if (key === SUBJECT_EDIT_STEPS.PREFERENCES) {
        result.preferences = value;
      }
      return result;
    },
    cleanTutorData(
      existingData: {
        personalInfo: any;
        currentEditableForm: string;
        availability: any;
        educationWorkHistory: any;
        guarantor: any;
        agreement: any;
        paymentInfo: any;
        others: any;
        identity: any;
        teachingProfile: any;
        currentStep: string;
        appData: any;
      },
      key,
      data: SubmissionType,
      nextStep: string,
      currentStep?: string,
    ) {
      const result = {
        personalInfo: existingData.personalInfo,
        agreement: existingData.agreement || {},
        availability: existingData.availability || {},
        educationWorkHistory: existingData.educationWorkHistory,
        identity: existingData.identity || {},
        paymentInfo: existingData.paymentInfo || {},
        others: existingData.others || {},
        teachingProfile: existingData.teachingProfile,
        appData: {
          currentEditableForm: nextStep,
          currentStep: currentStep,
          receiveJobs: existingData.appData?.receiveJobs,
          dateSubmitted: existingData.appData?.dateSubmitted,
        },
      };
      let value = data[key];

      if (key === STEPS.PERSONAL_INFO) {
        let { subscription, nationality, others = {}, ...rest } = value;
        result.personalInfo = {
          ...existingData.personalInfo,
          ...rest,
          country: nationality,
        };
        result.others = others;
        result.appData.receiveJobs = subscription;
      }
      if (key === STEPS.LOCATION_INFO) {
        let {
          exemptedAreas,
          lessonType,
          country,
          supportedCountryAccount,
          ...rest
        } = value;
        result.paymentInfo = {
          ...existingData.paymentInfo,
          country: supportedCountryAccount,
        };
        result.personalInfo = {
          ...existingData.personalInfo,
          locationCountry: country,
          ...rest,
        };
        result.availability = {
          ...existingData.availability,
          exemptedAreas,
          preferredLessonType: lessonType,
        };
      }
      if (
        [
          STEPS.EDUCATION_HISTORY,
          STEPS.WORK_HISTORY,
          STEPS.GUARANTOR_INFO,
        ].includes(key)
      ) {
        result.educationWorkHistory = {
          ...existingData.educationWorkHistory,
          ...value,
        };
      }

      if (key === STEPS.SCHEDULE_INFO) {
        result.availability = {
          ...result.availability,
          ...existingData.availability,
          ...value,
        };
      }

      if (key === STEPS.AGREEMENT_INFO) {
        result.agreement = { ...existingData.agreement, ...value };
      }
      if (key === STEPS.PAYMENT_INFO) {
        result.paymentInfo = { ...existingData.paymentInfo, ...value };
      }

      if (key === STEPS.TEACHING_PROFILE) {
        result.teachingProfile = {
          ...existingData.teachingProfile,
          ...value,
        };
      }
      if (key === STEPS.VERIFICATION) {
        result.identity = {
          ...existingData.identity,
          ...value,
        };
      }

      if ([STEPS.NEW_DEVELOPMENT, STEPS.VIDEO_SUMMARY].includes(key)) {
        result.others = { ...existingData.others, ...value };
      }
      if (key === "lastStep") {
        result.appData.dateSubmitted = value.dateSubmitted;
        result.others.canApply = value.canApply;
        // result.appData.currentStep = value.currentStep;
      }
      if (key === STEPS.POST_APPLICATION_1) {
        let {
          exemptedAreas,
          lessonType,
          country,
          supportedCountryAccount,
          ...rest
        } = value.locationInfo;
        result.personalInfo = {
          ...existingData.personalInfo,
          locationCountry: country,
          ...rest,
        };
        result.paymentInfo = {
          ...existingData.paymentInfo,
          ...value.paymentInfo,
          country: supportedCountryAccount,
        };
        result.availability = {
          ...existingData.availability,
          ...value.availability,
          exemptedAreas,
          preferredLessonType: lessonType,
        };
        result.teachingProfile = {
          ...existingData.teachingProfile,
          ...value.teachingProfile,
        };
        result.paymentInfo = {
          ...existingData.paymentInfo,
          ...value.paymentInfo,
          country: supportedCountryAccount,
        };
      }
      if (key === STEPS.POST_APPLICATION_2) {
        result.educationWorkHistory = {
          ...existingData.educationWorkHistory,
          ...value.educationWorkHistory,
        };
        result.others = { ...existingData.others, ...value.others };
        result.agreement = { ...existingData.agreement, ...value.agreement };
      }
      if (value.canApply) {
        result.others.canApply = value.canApply;
      }
      return result;
    },
    async saveTutorSubjects(subjects) {
      return await _adapter.saveTutorSubjects(subjects.map((o) => o.name));
    },
    async sendEmailVerification(data: any) {
      return await _adapter.sendEmailVerification(data);
    },
    async submitVideoRecording(url) {
      return await _adapter.submitVideoRecording(url);
    },
    async saveTutorInfo(
      key: string,
      value: any,
      slug: string,
      nextStep: string,
      currentStep: string,
    ) {
      let tutorInfo = _adapter.loadExistingTutorInfo();
      let data = this.cleanTutorData(
        tutorInfo,
        key,
        { [key]: value },
        nextStep,
        currentStep,
      );
      return await _adapter.saveTutorInfo({ slug, data });
    },
    saveSubjectImages: async (files) => {
      return await _adapter.saveSubjectImages(files);
    },
    checkSpellingAndGrammar: async (checks) => {
      return await _adapter.checkSpellingAndGrammar(checks);
    },
    deleteSubjectImage: async (photoId) => {
      return await _adapter.remoteDeleteImage({ public_id: photoId });
    },
    async updateTutorSubjectInfo(key: string, values: any, subject_id: any) {
      // let subjectInfo = _adapter.loadExistingSubject(subject_id);
      // let result = this.cleanSubjectData(subjectInfo, key, values);
      return await _adapter.updateTutorSubjectInfo(values, subject_id);
    },
    submitSelectedSubjects: async (data) => {
      return await _adapter.submitSelectedSubjects(data);
    },
    fetchBanksInfo: async (supportedCountry) => {
      return await _adapter.fetchBanksInfo(supportedCountry);
    },

    uploadApiHandler: async (
      files,
      options: { folder: string; unique?: boolean },
    ) => {
      //this is where cloudinary implementation is used.
      return await _adapter.uploadApiHandler(files, options);
    },
    cloudinaryApiHandler: async (files, progressCallback) => {
      return await _adapter.cloudinaryApiHandler(files, progressCallback);
    },
    remoteDeleteImage: async (files) => {
      return await _adapter.remoteDeleteImage(files);
    },
    postResults: async (name, gradedResult, flagged) => {
      return await _adapter.submitQuizResults({
        name: name,
        grading: gradedResult,
        flagged,
      });
    },
    buildQuizToTake: async (subjectInfo) => {
      return await _adapter.buildQuizData(subjectInfo);
    },
    beginQuiz: async (payload, subject_data) => {
      return await _adapter.beginQuiz(payload, subject_data);
    },
    saveSubject: (subject_id, subject) => {
      return _adapter.saveSubject(subject_id, subject);
    },
    createQuizFromSheet: (subject) => {
      return _adapter.createQuizFromSheet(subject);
    },
    saveOnBlur: (name, value) => {
      return _adapter.saveOnBlur(subjectDescriptionMapping[name], value);
    },
    loadSubjectDescription: (name) => {
      return _adapter.loadSubjectDescription(subjectDescriptionMapping[name]);
    },
    getEarningPercentage() {
      return _adapter.getEarningPercentage();
    },
    async getPriceSuggestion(subject) {
      return await _adapter.getPriceSuggestion(subject);
    },
    updateTutorResponse: async (payload, requestSlug, tutorSlug, agent) => {
      return _adapter.updateTutorResponse(
        payload,
        requestSlug,
        tutorSlug,
        agent,
      );
    },
    bookLessons: async (requestSlug, sessions) => {
      return await _adapter.bookLessons(requestSlug, sessions);
    },
    async validateFormStep(formValues, step) {
      if (step === STEPS.PERSONAL_INFO) {
        return await _adapter.validatePersonalInfo(formValues);
      }
    },
  };
}
